export { Permit } from './permit/permit';
export { Overtime } from './overtime/overtime';
export { UserPresensi } from './user/user';


// WEBPACK FOOTER //
// ./src/providers/presensi/index.ts